<template>
  <div class="leave-record">
    <div class="template-box" v-for="record in records" :key="record.times">
      <div class="first-line">
        <!-- <img :src="record.imgUrl" alt /> -->
        <span v-text="record.name"></span>
        <span>{{record.createtime | filterA}}</span>
      </div>
      <div class="second-line">
        <span>留言内容：</span>
        <span v-text="record.memo"></span>
      </div>
      <div class="third-line">
        <span>回复内容：</span>
        <span v-text="record.replycontent"></span>
        <p>{{record.replytime | filterA}}</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      records: []
    };
  },
  methods: {
    getMsg() {
      this.axios
        .post("/api/Personal/Message", {
          headline: sessionStorage.getItem("token")
        })
        .then(e => {
          console.log(e.data);
          if (e.data.code == 0) {
            this.records = e.data.msg;
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  mounted() {
    this.getMsg();
  },
  filters:{
    filterA: function(value) {
      if (value == undefined) return;
      return value.split("T")[0];
    },
  }
};
</script>
<style lang='scss' scoped>
.leave-record {
  .template-box {
    .third-line {
      p {
        color: #999999;
        text-align: right;
      }
      span {
        &:nth-child(2) {
          color: #999999;
        }
      }
      padding: 0.2rem;
      background: #fff;
    }
    .second-line {
      span {
        &:nth-child(2) {
          color: #999999;
        }
      }
      padding: 0.2rem;
      border-bottom: 0.01rem solid #e6e6e6;
      background: #fff;
    }
    .first-line {
      span {
        &:last-child {
          margin-left: auto;
        }
      }
      img {
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        margin-right: 0.2rem;
      }
      border-bottom: 0.01rem solid #e6e6e6;
      line-height: 3;
      display: flex;
      align-items: center;
      background: #fff;
      padding: 0 0.2rem;
    }

    padding: 0.2rem;
  }
  padding-top: 1rem;
  font-size: 0.3rem;
}
</style>